<template>
    <div>
        <!-------------------------------------------------------------- Ajout de produit ---------------------------------------------------------------->
        <h4>Ajout de ligne</h4>
        <div class="addProduct">
            <div class="fonctProduct">
                <el-radio-group size="small" v-model="selectedTypeLine">
                    <el-radio-button v-for="item in typeLine" :key="item" :label="item.value">{{ item.text }}</el-radio-button>
                </el-radio-group>
                <el-button-group class="fonctSupp">
                    <el-button size="small" v-on:click="addTitle" type="primary">Ajouter un titre</el-button>
                    <el-button size="small" v-on:click="addLineText" type="primary">Ajouter une ligne de texte</el-button>
                    <el-button size="small" v-on:click="addUnderTotal" type="primary">Ajouter un sous-total</el-button>
                    <el-button size="small" v-on:click="addGlobalPercent" type="primary">Appliquer un pourcentage global</el-button>
                </el-button-group>
            </div>

            <div v-if="selectedTypeLine == 1">
                <div>
                    <el-radio-group size="small" v-model="selectedProductType">
                    <el-radio-button v-for="item in productType" :key="item" :label="item.value">{{ item.text }}</el-radio-button>
                    </el-radio-group>
                </div>

                <div class="freeProduct">
                    <el-table
                    :data="[1]"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        label="Description"
                        width="500">
                        <template>
                        <wysiwyg class="descFreeProduct" v-model="freeProduct.desc" />
                        <div v-if="selectedProductType == 1">
                            <span>Si produit de type service à durée limitée :</span>
                            <el-date-picker
                            v-model="freeProduct.dateService"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="Date de début"
                            end-placeholder="Date de fin"
                            class="dateServiceProduct">
                            </el-date-picker>
                        </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Taux TVA">
                        <template>
                        <el-select class="tvaFreeProduct" v-model="freeProduct.tauxTVA" placeholder="Select">
                            <el-option
                            v-for="item in tauxTVA"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Prix unitaire de revient">
                        <template>
                        <el-input class="inputFreeProduct" v-model="freeProduct.puHT"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Quantité">
                        <template>
                        <el-input class="inputFreeProduct" v-model="freeProduct.qte"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Réduction">
                        <template>
                        <el-input class="inputFreeProduct" suffix-icon="fas fa-percent" v-model="freeProduct.reduc"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Prix de revient">
                        <template>
                        <el-input class="inputFreeProduct" v-model="freeProduct.prixRevient"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Taux de marque">
                        <template>
                        <el-input class="inputFreeProduct" suffix-icon="fas fa-percent" v-model="freeProduct.tauxMarque"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template>
                        <el-button type="success" icon="fas fa-plus" :click="addProductFree" circle></el-button>
                        <el-button type="danger" icon="fas fa-trash" :click="deleteProductFree" circle></el-button>
                        </template>
                    </el-table-column>
                    </el-table>
                </div>
            </div>

            <div v-else-if="selectedTypeLine == 2">
                <div class="searchProduct">
                    <el-autocomplete v-model="productSearch" :fetch-suggestions="querySearchAsync" placeholder="Rechercher un produit" @select="handleSelect" :clear="deleteProductPredef" :clearable="true">
                    <template slot-scope="{ item }">
                        <div class="value">
                        <el-popover
                            placement="top"
                            width="500"
                            trigger="hover"
                            popper-class="productPopover">
                            <p>
                            <b>{{ item.value }}</b>
                            </p>
                            <div class="contentPopover">
                            <div v-if="item.images.length" class="imgProduct">
                                <el-carousel height="150px" type="card">
                                <el-carousel-item v-for="item in item.images" :key="item">
                                    <img style="width:200px;" v-bind:src="'/api/getImagesProduct?path='+item.encodedURI" :alt="item.name"/>
                                </el-carousel-item>
                                </el-carousel>
                            </div>
                            <div class="descriptionProduct">
                                <p>
                                <b>Référence :</b> {{ item.ref }}
                                </p>
                                <p>
                                <b>Prix HT :</b> {{ item.prixHT }}
                                </p>
                                <p>
                                <b>Taux TVA :</b> {{ item.tauxTVA }}
                                </p>
                                <p>
                                <b>Prix TTC :</b> {{ item.prixTTC }}
                                </p>
                                <p>
                                <b>Description :</b>
                                <span v-html="item.description"></span>
                                </p>
                            </div>
                            </div>
                            <i class="far fa-question-circle" slot="reference"></i><span slot="reference">{{ " "+item.value }}</span>
                        </el-popover>
                        </div>
                    </template>
                    </el-autocomplete>
                    <el-button v-if="selectedProduct" type="success" class="addProductPredef" icon="fas fa-plus" v-on:click="addProductPredef" circle></el-button>
                </div>
            </div>
        </div>
        <!---------------------------------------------------------------- Fin ajout de produit ------------------------------------------------>

        <!---------------------------------------------------------- Liste des produit ---------------------------------------------------------->
        <div class="listProduct">
            <table class='table'>
                <thead>
                    <tr>
                        <template v-for="item in headerTableProduct">
                        <th :key="item.key" scope='col'>{{ item.label }}</th>
                        </template>
                    </tr>
                </thead>
                <tbody tag='tbody' v-model='tableProduct' is='draggable' @end="onEnd" group='items'>
                    <tr v-for='item in tableProduct' :key='item.id'>
                        <template v-if="item.productType == 9 && (item.quantite > 89 || item.quantite < 100)">
                            <td scope='row'>
                              <i class="fas fa-arrows-alt"></i>
                            </td>

                            <td scope='row' colspan="7" style="text-align:right;" v-html='item.description +" :"'></td>

                            <td scope='row' v-if="productTopExist(item)"> <b>{{ getTotalTopProduct(item) + " €" }}</b> </td>
                            <td scope='row' v-else></td>

                            <td scope='row'>
                              <a style='text-align:center;' v-on:click.stop="modifyLine(item)"><span style="cursor:pointer; color:black;" class='far fa-edit' v-b-popover.hover="'Modifier cette ligne'"></span></a>
                            </td>
                            <td scope='row'>
                              <a style='text-align:center;' v-on:click.stop="deleteLine(item.id)"><span style="cursor:pointer; color:red;" class='fas fa-times' v-b-popover.hover="'Supprimer cette ligne'"></span></a>
                            </td>
                        </template>
                        <template v-else>
                            <td scope='row'>
                              <i class="fas fa-arrows-alt"></i>
                            </td>

                            <td scope='row' v-html="item.description"></td>

                            <td scope='row'>{{item.ref}}</td>

                            <td scope='row'> {{ item.quantite }} </td>

                            <td scope='row' v-if="item.paht"> {{ item.paht + " €" }} </td>
                            <td scope='row' v-else></td>

                            <td scope='row' v-if="item.pvht"> {{ item.pvht + " €" }} </td>
                            <td scope='row' v-else></td>

                            <td scope='row' v-if="item.tva"> {{ item.tva + " %" }} </td>
                            <td scope='row' v-else></td>

                            <td scope='row' v-if="item.marque"> {{ item.marque + " %" }} </td>
                            <td scope='row' v-else></td>

                            <td scope='row' v-if="item.totalht"> {{ item.totalht + " €" }} </td>
                            <td scope='row' v-else></td>

                            <td scope='row'>
                              <a style='text-align:center;' v-on:click.stop="modifyLine(item)"><span style="cursor:pointer; color:black;" class='far fa-edit' v-b-popover.hover="'Modifier cette ligne'"></span></a>
                            </td>
                            <td scope='row'>
                              <a style='text-align:center;' v-on:click.stop="deleteLine(item.id)"><span style="cursor:pointer; color:red;" class='fas fa-times' v-b-popover.hover="'Supprimer cette ligne'"></span></a>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--------------------------------------------------------- Fin de la liste des produits ------------------------------------------------------------------>

        <!------------------------------------------------------- Ajout produit modal ---------------------------------------------------------------------------------->
        <b-modal id="modalLine" @hide="resetModal" :title="lineToAdd.label" hide-footer>
            <template>
                <el-form ref="formLineToAdd" id="formAddLine" label-position="top" :inline="true" :model="lineToAdd" label-width="120px">
                <el-form-item class="selectLineToAdd" label="Taux de TVA">
                    <el-select v-model="lineToAdd.tva_tx" placeholder="Select">
                    <el-option
                        v-for="item in tauxTVA"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="inputLineToAdd" label="Prix unitaire HT">
                    <el-input v-model="lineToAdd.subprice"></el-input>
                </el-form-item>

                <el-form-item class="inputLineToAdd" label="Quantité">
                    <el-input v-model="lineToAdd.qty"></el-input>
                </el-form-item>

                <el-form-item class="inputLineToAdd" label="Remise">
                    <el-input suffix-icon="fas fa-percent" v-model="lineToAdd.remise_percent"></el-input>
                </el-form-item>

                <el-form-item class="inputLineToAdd" label="Prix d'achat HT">
                    <el-input v-model="lineToAdd.pa_ht"></el-input>
                </el-form-item>
                
                <el-form-item class="selectLineToAdd" label="Sous-partie">
                    <el-select v-model="parentRang" placeholder="Select">
                    <el-option
                        label=""
                        value="">
                    </el-option>
                    <el-option
                        v-for="item in propalePart"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="success" @click.native.prevent="submitLine" class="">AJOUTER</el-button>
                </el-form-item>
                </el-form>
            </template>
        </b-modal>
        <!------------------------------------------------------- Fin ajout produit modal ---------------------------------------------------------------------------------->
        
        <!------------------------------------------------------- Modification produit modal ---------------------------------------------------------------------------------->
        <b-modal id="modalModifyLine" @hide="resetModal" :title="'Modification de ligne n°'+lineToModify.rang" hide-footer>
            <template>
                <el-form ref="formLineToModify" id="formModifyLine" label-position="top" :inline="true" :model="lineToModify" label-width="120px">
                  <el-form-item v-if="(lineToModify.product_type == 0 || lineToModify.product_type == 1)" class="textareaLineToModify" label="Libelle">
                    <wysiwyg @change="changeLibelle" v-model="lineToModify.libelle" />
                  </el-form-item>

                  <el-form-item v-if="(lineToModify.product_type == 9 && lineToModify.qty == 50)" class="textareaLineToModify" label="Description">
                    <wysiwyg @change="changeDesc" v-model="lineToModify.description" />
                  </el-form-item>

                  <el-form-item v-if="(lineToModify.product_type == 0 || lineToModify.product_type == 1)" class="selectLineToModify" label="Taux de TVA">
                      <el-select @change="changeTVA" v-model="lineToModify.tva_tx" placeholder="Select">
                          <el-option
                              v-for="item in tauxTVA"
                              :key="item.value"
                              :label="item.text"
                              :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item v-if="(lineToModify.product_type == 0 || lineToModify.product_type == 1)" class="inputLineToModify" label="Prix unitaire HT">
                      <el-input @change="changePuHt" v-model="lineToModify.subprice"></el-input>
                  </el-form-item>

                  <el-form-item v-if="(lineToModify.product_type == 0 || lineToModify.product_type == 1)" class="inputLineToModify" label="Quantité">
                      <el-input @change="changeQuantite" v-model="lineToModify.qty"></el-input>
                  </el-form-item>

                  <el-form-item v-if="(lineToModify.product_type == 0 || lineToModify.product_type == 1)" class="inputLineToModify" label="Remise">
                      <el-input @change="changeRemise" suffix-icon="fas fa-percent" v-model="lineToModify.remise_percent"></el-input>
                  </el-form-item>

                  <el-form-item v-if="(lineToModify.product_type == 0 || lineToModify.product_type == 1)" class="inputLineToModify" label="Prix d'achat HT">
                      <el-input @change="changePaHt" v-model="lineToModify.pa_ht"></el-input>
                  </el-form-item>

                  <el-form-item v-if="(lineToModify.product_type == 0 || lineToModify.product_type == 1)" class="inputLineToModify" label="Taux de marque">
                      <el-input @change="changeMarque" suffix-icon="fas fa-percent" v-model="lineToModify.marque_tx"></el-input>
                  </el-form-item>

                  <el-form-item v-if="lineToModify.product_type == 9 && lineToModify.qty == 50" class="selectLineToModify" label="Groupement">
                      <el-select v-model="parentRang" placeholder="Select">
                          <el-option
                              label=""
                              value="">
                          </el-option>
                          <el-option
                              v-for="item in propalePart"
                              :key="item.value"
                              :label="item.text"
                              :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item v-if="lineToModify.product_type == 9 && ((lineToModify.qty > 0 && lineToModify.qty < 10) || (lineToModify.qty > 89 && lineToModify.qty < 100))" class="inputLineToModify" label="Titre">
                      <el-input @change="changeLabel" v-model="lineToModify.label"></el-input>
                  </el-form-item>
                  
                  <el-form-item v-if="lineToModify.product_type == 9 && (lineToModify.qty > 0 && lineToModify.qty < 10)" class="selectLineToModify" label="Niveau">
                      <el-select v-model="lineToModify.qty" placeholder="Select">
                        <el-option
                            v-for="item in levelTitle"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item v-if="lineToModify.product_type == 9 && (lineToModify.qty > 89 && lineToModify.qty < 100)" class="selectLineToModify" label="Niveau">
                      <el-select v-model="lineToModify.qty" placeholder="Select">
                        <el-option
                            v-for="item in levelSousTotal"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item>
                      <el-button type="success" @click.native.prevent="submitModify" class="">ENREGISTRER</el-button>
                  </el-form-item>
                </el-form>
            </template>
        </b-modal>
        <!------------------------------------------------------- Fin modification produit modal ---------------------------------------------------------------------------------->

        <!------------------------------------------------------- Ajout titre modal ---------------------------------------------------------------------------------->
        <b-modal id="modalTitle" @hide="resetModal" title="Ajout de titre" hide-footer>
            <template>
                <el-form ref="formTitleToAdd" id="formTitleToAdd" label-position="top" :inline="true" :model="lineToAdd" label-width="120px">
                  <el-form-item class="inputTitle" label="Titre">
                      <el-input v-model="lineToAdd.label"></el-input>
                  </el-form-item>
                  
                  <el-form-item class="selectTitleLevel" label="Niveau">
                      <el-select v-model="lineToAdd.qty" placeholder="Select">
                        <el-option
                            v-for="item in levelTitle"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item>
                      <el-button type="success" @click.native.prevent="submitTitle" class="">AJOUTER</el-button>
                  </el-form-item>
                </el-form>
            </template>
        </b-modal>
    <!------------------------------------------------------- Fin ajout titre modal ---------------------------------------------------------------------------------->

    <!------------------------------------------------------- Ajout sous-total modal ---------------------------------------------------------------------------------->
        <b-modal id="modalSousTotal" @hide="resetModal" title="Ajout de sous-total" hide-footer>
            <template>
                <el-form ref="formSousTotalToAdd" id="formSousTotalToAdd" label-position="top" :inline="true" :model="lineToAdd" label-width="120px">
                  <el-form-item class="inputTitle" label="Sous-total">
                      <el-input v-model="lineToAdd.label"></el-input>
                  </el-form-item>
                  
                  <el-form-item class="selectTitleLevel" label="Niveau">
                      <el-select v-model="lineToAdd.qty" placeholder="Select">
                        <el-option
                            v-for="item in levelSousTotal"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item>
                      <el-button type="success" @click.native.prevent="submitSousTotal" class="">AJOUTER</el-button>
                  </el-form-item>
                </el-form>
            </template>
        </b-modal>
    <!------------------------------------------------------- Fin ajout sous-total modal ---------------------------------------------------------------------------------->

    <!------------------------------------------------------- Ajout texte modal ---------------------------------------------------------------------------------->
        <b-modal id="modalText" @hide="resetModal" title="Ajout de texte" hide-footer>
            <template>
                <el-form ref="formTextToAdd" id="formTextToAdd" label-position="top" :inline="true" :model="lineToAdd" label-width="120px">
                  <el-form-item class="textareaLineToAdd" label="Description">
                      <wysiwyg v-model="lineToAdd.description" />
                  </el-form-item>
                  
                  <el-form-item class="selectLineToAdd" label="Groupement">
                      <el-select v-model="parentRang" placeholder="Select">
                      <el-option
                          label=""
                          value="">
                      </el-option>
                      <el-option
                          v-for="item in propalePart"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value">
                      </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item>
                      <el-button type="success" @click.native.prevent="submitLineText" class="">AJOUTER</el-button>
                  </el-form-item>
                </el-form>
            </template>
        </b-modal>
    <!------------------------------------------------------- Fin ajout texte modal ---------------------------------------------------------------------------------->

    <!------------------------------------------------------- Ajout pourcentage global modal ---------------------------------------------------------------------------------->
        <b-modal id="modalGlobalPourcent" @hide="resetModal" title="Ajout d'un pourcentage global" hide-footer>
            <template>
                <el-form ref="formGlobalPourcentToAdd" id="formGlobalPourcentToAdd" label-position="top" :inline="true" label-width="120px">
                  <el-form-item class="inputTitle" label="Pourcentage">
                      <el-input v-model="globalPercent"></el-input>
                      <p>Applique la formule suivante sur le prix unitaire de chaque lignes PUHT x (1+VALEUR/100)</p>
                  </el-form-item>

                  <el-form-item>
                      <el-button type="success" @click.native.prevent="submitGlobalPourcent" class="">AJOUTER</el-button>
                  </el-form-item>
                </el-form>
            </template>
        </b-modal>
    <!------------------------------------------------------- Fin ajout pourcentage globals modal ---------------------------------------------------------------------------------->
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import fr from '../../../../../node_modules/vuejs-datepicker/dist/locale/translations/fr.js'
import script from '../../../../script/script.js'
import scriptTiers from '../../../../script/script_tiers.js'
import scriptPropale from '../../../../script/script_propale.js'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
var moment = require('moment');
function initialState (){
  return {
    isTiers: false,
    selectedTypeLine: '2',
    typeLine: [
      {value: '1', text: 'Libre'},
      {value: '2', text: 'Prédéfini'}
    ],
    selectedProductType: 0,
    productType: [
      {value: 0, text: 'Produit'},
      {value: 1, text: 'Service'}
    ],
    products: [],
    productSearch: '',
    timeout: null,
    fieldsProducts: [
      {label: 'Description', key:'description'},
      {label: 'TVA', key:'tva'},
      {label: 'P.U HT', key:'prixUnitaire'},
      {label: 'Quantité', key:'qty'},
      {label: 'Réduction', key:'reduction'},
      {label: 'Total HT', key:'totalHt'},
      {label: '', key: 'edit'},
      {label: '', key: 'del'}
    ],
    tauxTVA: [
      {value: "20.00", text: "20.00 %"},
      {value: "10.00", text: "10.00 %"},
      {value: "5.50", text: "5.50 %"},
      {value: "0", text: "0 %"}
    ],
    editor: ClassicEditor,
    editorConfig:{
      
    },
    limitedService: {
      start: '',
      finish: ''
    },
    editorOption: {
      modules: {
        toolbar: '#toolbar'
      }
    },
    selectedProduct:null,
    freeProduct:{
      desc:"",
      tauxTVA:"20.000",
      puHT:"",
      qte:1,
      reduc:"0",
      prixRevient:"",
      tauxMarque:"",
      dateService:[]
    },
    listAuthor:[],
    headerTableProduct:[
      {
        key:"reorder",
        label:""
      },
      {
        key:"libelle",
        label:"Libelle"
      },
      {
        key:"ref",
        label:"Ref."
      },
      {
        key:"quantite",
        label:"Quantité"
      },
      {
        key:"paht",
        label:"Pa HT"
      },
      {
        key:"pvht",
        label:"Pv HT"
      },
      {
        key:"tva",
        label:"Tx TVA"
      },
      {
        key:"marque",
        label:"Tx Marque"
      },
      {
        key:"totalht",
        label:"Total HT"
      },
      {
        key:"edit",
        label:""
      },
      {
        key:"delete",
        label:""
      },
    ],
    lineToAdd : {
      fk_parent_line: null,
      desc: "",
      fk_product: "",
      fk_product_type: "",
      product_type: "",
      qty: "",
      tva_tx: "",
      vat_src_code: "",
      subprice: "",
      remise_percent: "0",
      fk_remise_except: null,
      rang: "",
      fk_fournprice: null,
      pa_ht: "",
      marge_tx: "",
      marque_tx: "",
      special_code: "",
      info_bits: "",
      total_ht: "",
      total_tva: "",
      total_ttc: "",
      remise: null,
      price: null,
      ref: "",
      product_ref: "",
      libelle: "",
      label: null,
      product_label: "",
      product_desc: "",
      product_tobatch: "",
      product_barcode: null,
      localtax1_tx: "",
      localtax2_tx: "",
      localtax1_type: "",
      localtax2_type: "",
      total_localtax1: "",
      total_localtax2: "",
      date_start: "",
      date_end: "",
      multicurrency_subprice: "",
      multicurrency_total_ht: "",
      multicurrency_total_tva: "",
      multicurrency_total_ttc: "",
      fk_unit: null,
      entity: null,
      import_key: null,
      array_options: [],
      array_languages: null,
      linkedObjectsIds: null,
      canvas: null,
      origin: null,
      origin_id: null,
      ref_ext: null,
      statut: null,
      status: null,
      state: null,
      state_id: null,
      state_code: null,
      region_id: null,
      barcode_type: null,
      barcode_type_code: null,
      barcode_type_label: null,
      barcode_type_coder: null,
      demand_reason_id: null,
      transport_mode_id: null,
      last_main_doc: null,
      fk_bank: null,
      fk_account: null,
      openid: null,
      lines: null,
      date_creation: null,
      date_validation: null,
      date_modification: null,
      specimen: 0,
      alreadypaid: null,
      description: "",
      weight: null,
      weight_units: null,
      volume: null,
      volume_units: null
    },
    parentRang:"",
    lineToModify:{},
    globalPercent:0
  }
}
export default {
  props: [
        "socid",
        "idPropale"
    ],
  data () {
    return initialState()
  },
  methods: {
    resetData(){
      Object.assign(this.$data, initialState())
    },
    detailsTiers: scriptTiers.detailsTiers,
    loadingDictionary: scriptTiers.loadingDictionary,
    loadPropale: scriptPropale.loadPropale,
    createPropal: script.createPropal,
    loadingClient: scriptTiers.loadingClient,
    verifyTiers () {
      if(this.socid!=null){
        this.detailsTiers(this.socid)
        this.isTiers = true
      }else{
        this.loadingClient()
      }
    },
    searchProducts: script.searchProducts,
    addProduct: script.addProduct,
    chooseProduct: script.chooseProduct,
    deleteProduct: script.deleteProduct,
    deleteProducts: script.deleteProducts,
    visualDevisTiers: scriptTiers.visualDevisTiers,
    deleteLinePropale: scriptPropale.deleteLinePropale,
    modifyLinePropale: scriptPropale.modifyLinePropale,
    convertNumber(x) {
      return Number.parseFloat(x).toFixed(2)
    },
    async querySearchAsync(queryString, cb) {
        this.products = await this.searchProducts(queryString)
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          cb(this.products)
        }, 3000 * Math.random())
    },
    handleSelect(item) {
        this.selectedProduct = item
    },
    resetModal(){
      this.resetData()
    },
    getImagesProduct: script.getImagesProduct,
    changeRang: scriptPropale.changeRang,
    addLinePropale: scriptPropale.addLinePropale,
    getInfosFournisseur: scriptPropale.getInfosFournisseur,
    async onEnd(item){
      let to = this.propale.lines.find(element => element.rang == item.newIndex+1)
      let from = this.propale.lines.find(element => element.rang == item.oldIndex+1)
      let reorderTable = []
      if(item.newIndex > item.oldIndex){
        reorderTable = this.propale.lines.filter(element => (element.rang <= item.newIndex+1)&&(element.rang != item.oldIndex+1))
      }else{
        reorderTable = this.propale.lines.filter(element => (element.rang >= item.newIndex+1)&&(element.rang != item.oldIndex+1))
      }
      await this.changeRang(to,from,reorderTable,this.propale.ref)
      this.loadPropale(this.idPropale)
    },

    //Ajout de produit prédéfini
    async addProductPredef(target){
      let found = this.propale.lines.find(element => element.fk_product == this.selectedProduct.id)
      let newLine = false
      if(found){
        if (confirm('Produit déjà selectionné, souhaitez-vous créer une nouvelle ligne ?')) {
          newLine = true
        }else{
          this.deleteProductPredef()
        }
      }else{
        newLine = true
      }
      if(newLine){
        //Récupération des infos du produit chez le fournisseur
        let fournisseur = await this.getInfosFournisseur(this.selectedProduct.details.id)
        //Mise en forme des données
        this.lineToAdd.desc = this.selectedProduct.details.description
        this.lineToAdd.fk_product = this.selectedProduct.details.id
        this.lineToAdd.fk_product_type = this.selectedProduct.details.type
        this.lineToAdd.product_type = this.selectedProduct.details.type
        this.lineToAdd.qty = 1
        this.lineToAdd.tva_tx = Number.parseFloat(this.selectedProduct.details.tva_tx).toFixed(2)
        this.lineToAdd.subprice = Number.parseFloat(this.selectedProduct.details.price).toFixed(2)
        this.lineToAdd.rang = Number.parseInt(this.propale.lines.length)+1
        this.lineToAdd.fk_fournprice = fournisseur.length ? fournisseur[0].fourn_price : 0
        this.lineToAdd.pa_ht = Number.parseFloat(fournisseur[0].fourn_price).toFixed(2)
        this.lineToAdd.marge_tx = Number.parseFloat(((Number.parseFloat(this.selectedProduct.details.price)-Number.parseFloat(fournisseur.length ? fournisseur[0].fourn_price : 0))/Number.parseFloat(this.selectedProduct.details.price))*100).toFixed(2)
        this.lineToAdd.marque_tx = Number.parseFloat(((Number.parseFloat(this.selectedProduct.details.price)-Number.parseFloat(fournisseur.length ? fournisseur[0].fourn_price : 0))/Number.parseFloat(fournisseur.length ? fournisseur[0].fourn_price : 0))*100).toFixed(2)
        this.lineToAdd.special_code = "0"
        this.lineToAdd.info_bits = "0"
        this.lineToAdd.total_ht = Number.parseFloat(this.lineToAdd.qty*this.selectedProduct.details.price)
        this.lineToAdd.total_tva = Number.parseFloat(this.lineToAdd.qty*((this.selectedProduct.details.price*this.selectedProduct.details.tva_tx)/100))
        this.lineToAdd.total_ttc = Number.parseFloat(this.lineToAdd.qty*this.selectedProduct.details.price)+Number.parseFloat(this.lineToAdd.qty*((this.selectedProduct.details.price*this.selectedProduct.details.tva_tx)/100))
        this.lineToAdd.ref = this.selectedProduct.details.ref
        this.lineToAdd.product_ref = this.selectedProduct.details.ref
        this.lineToAdd.libelle = this.selectedProduct.details.label
        this.lineToAdd.label = this.selectedProduct.details.label
        this.lineToAdd.product_label = this.selectedProduct.details.label
        this.lineToAdd.product_desc = this.selectedProduct.details.description
        this.lineToAdd.product_tobatch = this.selectedProduct.details.status_batch
        this.lineToAdd.product_barcode = null
        this.lineToAdd.localtax1_tx = this.selectedProduct.details.localtax1_tx
        this.lineToAdd.localtax2_tx = this.selectedProduct.details.localtax2_tx
        this.lineToAdd.localtax1_type = this.selectedProduct.details.localtax1_type
        this.lineToAdd.localtax2_type = this.selectedProduct.details.localtax2_type
        this.lineToAdd.total_localtax1 = this.selectedProduct.details.total_localtax1
        this.lineToAdd.total_localtax2 = this.selectedProduct.details.total_localtax2
        this.lineToAdd.date_start = ""
        this.lineToAdd.date_end = ""
        this.lineToAdd.multicurrency_subprice = this.lineToAdd.subprice
        this.lineToAdd.multicurrency_total_ht = this.lineToAdd.total_ht
        this.lineToAdd.multicurrency_total_tva = this.lineToAdd.total_tva
        this.lineToAdd.multicurrency_total_ttc = this.lineToAdd.total_ttc
        this.lineToAdd.fk_unit = this.selectedProduct.details.fk_unit
        this.lineToAdd.entity = this.selectedProduct.details.entity
        this.lineToAdd.import_key = this.selectedProduct.details.import_key
        this.lineToAdd.array_options = this.selectedProduct.details.array_options
        this.lineToAdd.array_languages = this.selectedProduct.details.array_languages
        this.lineToAdd.linkedObjectsIds = this.selectedProduct.details.linkedObjectsIds
        this.lineToAdd.canvas = this.selectedProduct.details.canvas
        this.lineToAdd.origin = this.selectedProduct.details.origin
        this.lineToAdd.origin_id = this.selectedProduct.details.origin_id
        this.lineToAdd.ref_ext = this.selectedProduct.details.ref_ext
        this.lineToAdd.statut = this.selectedProduct.details.statut
        this.lineToAdd.status = this.selectedProduct.details.status
        this.lineToAdd.state = this.selectedProduct.details.state
        this.lineToAdd.state_id = this.selectedProduct.details.state_id
        this.lineToAdd.state_code = this.selectedProduct.details.state_code
        this.lineToAdd.region_id = this.selectedProduct.details.region_id
        this.lineToAdd.barcode_type = this.selectedProduct.details.barcode_type
        this.lineToAdd.barcode_type_code = this.selectedProduct.details.barcode_type_code
        this.lineToAdd.barcode_type_label = this.selectedProduct.details.barcode_type_label
        this.lineToAdd.barcode_type_coder = this.selectedProduct.details.barcode_type_coder
        this.lineToAdd.demand_reason_id = this.selectedProduct.details.demand_reason_id
        this.lineToAdd.transport_mode_id = this.selectedProduct.details.transport_mode_id
        this.lineToAdd.last_main_doc = this.selectedProduct.details.last_main_doc
        this.lineToAdd.fk_bank = this.selectedProduct.details.fk_bank
        this.lineToAdd.fk_account = this.selectedProduct.details.fk_account
        this.lineToAdd.openid = this.selectedProduct.details.openid
        this.lineToAdd.lines = this.selectedProduct.details.lines
        this.lineToAdd.date_creation = ""
        this.lineToAdd.date_validation = ""
        this.lineToAdd.date_modification = ""
        this.lineToAdd.specimen = this.selectedProduct.details.specimen
        this.lineToAdd.alreadypaid = this.selectedProduct.details.alreadypaid
        this.lineToAdd.description = this.selectedProduct.details.description
        this.lineToAdd.weight = this.selectedProduct.details.weight
        this.lineToAdd.weight_units = this.selectedProduct.details.weight_units
        this.lineToAdd.volume = this.selectedProduct.details.volume
        this.lineToAdd.volume_units = this.selectedProduct.details.volume_units

        //Appel au modal
        this.$root.$emit('bv::show::modal', 'modalLine',target)
      }
    },
    async submitLine(){
      let errors = []
      this.lineToAdd.qty = Number.parseInt(this.lineToAdd.qty)
      this.lineToAdd.subprice = Number.parseFloat(this.lineToAdd.subprice).toFixed(2)
      this.lineToAdd.remise_percent = Number.parseFloat(this.lineToAdd.remise_percent).toFixed(2)
      this.lineToAdd.pa_ht = Number.parseFloat(this.lineToAdd.pa_ht).toFixed(2)

      if((isNaN(this.lineToAdd.qty))||(this.lineToAdd.qty <= 0)){
        errors.push({content:"La quantité doit être un entier supérieur à 0",title:"Ajout impossible"})
      }
      if((isNaN(this.lineToAdd.subprice))||(this.lineToAdd.subprice <= 0)){
        errors.push({content:"Le prix unitaire HT doit être un nombre supérieur à 0",title:"Ajout impossible"})
      }
      if((isNaN(this.lineToAdd.remise_percent))||(this.lineToAdd.remise_percent < 0)){
        errors.push({content:"La remise doit être un nombre supérieur à 0",title:"Ajout impossible"})
      }
      if((isNaN(this.lineToAdd.pa_ht))||(this.lineToAdd.pa_ht <= 0)){
        errors.push({content:"Le prix d'achat HT doit être un nombre supérieur à 0",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        let remise = 0
        this.lineToAdd.tva_tx = Number.parseFloat(this.lineToAdd.tva_tx).toFixed(2)
        this.lineToAdd.marque_tx = Number.parseFloat(((Number.parseFloat(this.lineToAdd.subprice)-Number.parseFloat(this.lineToAdd.fk_fournprice))/Number.parseFloat(this.lineToAdd.subprice))*100).toFixed(2)
        this.lineToAdd.marge_tx = Number.parseFloat(((Number.parseFloat(this.lineToAdd.subprice)-Number.parseFloat(this.lineToAdd.fk_fournprice))/Number.parseFloat(this.lineToAdd.fk_fournprice))*100).toFixed(2)
        if(this.lineToAdd.remise_percent){
          remise = Number.parseFloat((this.lineToAdd.subprice*this.lineToAdd.qty)*(this.lineToAdd.remise_percent/100)).toFixed(2)
        }
        this.lineToAdd.total_ht = Number.parseFloat(this.lineToAdd.qty*this.lineToAdd.subprice)-remise
        this.lineToAdd.total_tva = Number.parseFloat(this.lineToAdd.qty*((this.lineToAdd.subprice*this.lineToAdd.tva_tx)/100))
        this.lineToAdd.total_ttc = Number.parseFloat(this.lineToAdd.total_ht+this.lineToAdd.total_tva).toFixed(2)
        this.lineToAdd.multicurrency_subprice = this.lineToAdd.subprice
        this.lineToAdd.multicurrency_total_ht = this.lineToAdd.total_ht
        this.lineToAdd.multicurrency_total_tva = this.lineToAdd.total_tva
        this.lineToAdd.multicurrency_total_ttc = this.lineToAdd.total_ttc
        this.lineToAdd.date_creation = moment().format("YYYY-MM-DD HH:mm:ss")
        let response = await this.addLinePropale(this.idPropale,this.lineToAdd,this.propale.ref)
        if(this.parentRang != ""){
          let to = {rang:Number.parseInt(this.parentRang)+1}
          let from = {rang:this.lineToAdd.rang, id:response.idLine}
          let reorderTable = []
          reorderTable = this.propale.lines.filter(element => (element.rang >= to.rang)&&(element.rang != this.lineToAdd.rang))
          await this.changeRang(to,from,reorderTable,this.propale.ref)
        }
        this.loadPropale(this.idPropale)
        this.resetData()

        //Hide modal
        this.$root.$emit('bv::hide::modal', 'modalLine')
      }
    },

    //Ajout de produit libre
    addProductFree(){

    },
    deleteProductPredef(){
      this.selectedProduct = null
    },
    deleteProductFree(){

    },
    async deleteLine(idLine){
      if (confirm('Voulez-vous supprimer la ligne ?')) {
        await this.deleteLinePropale(this.idPropale,idLine,this.propale.ref)
        this.loadPropale(this.idPropale)
      }
    },

    //Ajout d'un titre
    addTitle(target){
      this.lineToAdd.qty = 1
      this.$root.$emit('bv::show::modal', 'modalTitle',target)
    },
    async submitTitle(){
      if(this.lineToAdd.label == ""){
        this.lineToAdd.label = "Titre de groupement"
      }
      this.lineToAdd.product_type = "9"
      this.lineToAdd.special_code = "104777"
      this.lineToAdd.rang = Number.parseInt(this.propale.lines.length)+1
      this.lineToAdd.date_creation = moment().format("YYYY-MM-DD HH:mm:ss")
      await this.addLinePropale(this.idPropale,this.lineToAdd,this.propale.ref)
      this.loadPropale(this.idPropale)
      this.resetData()
      //Hide modal
      this.$root.$emit('bv::hide::modal', 'modalTitle')
    },
    

    //Ajout d'une ligne de texte
    addLineText(){
      this.$root.$emit('bv::show::modal', 'modalText')
    },
    async submitLineText(){
      if(this.lineToAdd.description == ""){
        this.lineToAdd.description = "Description ..."
      }

      this.lineToAdd.desc = this.lineToAdd.description
      this.lineToAdd.product_type = "9"
      this.lineToAdd.qty = "50"
      this.lineToAdd.special_code = "104777"
      this.lineToAdd.rang = Number.parseInt(this.propale.lines.length)+1
      this.lineToAdd.date_creation = moment().format("YYYY-MM-DD HH:mm:ss")
      let response = await this.addLinePropale(this.idPropale,this.lineToAdd,this.propale.ref)
      if(this.parentRang != ""){
        let to = {rang:Number.parseInt(this.parentRang)+1}
        let from = {rang:this.lineToAdd.rang, id:response.idLine}
        let reorderTable = []
        reorderTable = this.propale.lines.filter(element => (element.rang >= to.rang)&&(element.rang != this.lineToAdd.rang))
        await this.changeRang(to,from,reorderTable,this.propale.ref)
      }
      this.loadPropale(this.idPropale)
      this.resetData()
      //Hide modal
      this.$root.$emit('bv::hide::modal', 'modalText')
    },

    //Ajout d'un pourcentage global
    addGlobalPercent(){
      this.$root.$emit('bv::show::modal', 'modalGlobalPourcent')
    },
    async submitGlobalPercent(){
      let errors = []
      this.globalPercent = Number.parseFloat(this.globalPercent).toFixed(2)

      if((isNaN(this.globalPercent))||(this.globalPercent < 0)){
        errors.push({content:"Le pourcentage global doit être un entier positif",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        let products = this.propale.lines.filter(line => line.product_type == 0 || line.product_type == 1)
        if(products.length){
          products.forEach(async product => {
            product.subprice = product.subprice * (this.globalPercent/100)
            product.marque_tx = Number.parseFloat(((Number.parseFloat(product.subprice)-Number.parseFloat(product.fk_fournprice))/Number.parseFloat(product.subprice))*100).toFixed(2)
            product.marge_tx = Number.parseFloat(((Number.parseFloat(product.subprice)-Number.parseFloat(product.fk_fournprice))/Number.parseFloat(product.fk_fournprice))*100).toFixed(2)
            if(product.remise_percent){
              remise = Number.parseFloat((product.subprice*product.qty)*(product.remise_percent/100)).toFixed(2)
            }
            product.total_ht = Number.parseFloat(product.qty*product.subprice)-remise
            product.total_tva = Number.parseFloat(product.qty*((product.subprice*product.tva_tx)/100))
            product.total_ttc = Number.parseFloat(product.total_ht+product.total_tva).toFixed(2)
            product.multicurrency_subprice = product.subprice
            product.multicurrency_total_ht = product.total_ht
            product.multicurrency_total_tva = product.total_tva
            product.multicurrency_total_ttc = product.total_ttc
            product.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
            await this.addLinePropale(this.idPropale,product,this.propale.ref)
          })
        }
        this.$root.$emit('bv::show::modal', 'modalGlobalPourcent')
      }
    },

    //Ajout d'un sous-total
    addUnderTotal(){
      this.lineToAdd.qty = 99
      this.$root.$emit('bv::show::modal', 'modalSousTotal')
    },
    async submitSousTotal(){
      if(this.lineToAdd.label == ""){
        this.lineToAdd.label = "Sous-total"
      }
      this.lineToAdd.product_type = "9"
      this.lineToAdd.special_code = "104777"
      this.lineToAdd.rang = Number.parseInt(this.propale.lines.length)+1
      this.lineToAdd.date_creation = moment().format("YYYY-MM-DD HH:mm:ss")
      await this.addLinePropale(this.idPropale,this.lineToAdd,this.propale.ref)
      this.loadPropale(this.idPropale)
      this.resetData()
      //Hide modal
      this.$root.$emit('bv::hide::modal', 'modalSousTotal')
    },

    //Modification de ligne
    modifyLine(line){
      this.lineToModify = JSON.parse(JSON.stringify(this.propale.lines.find(element => element.id == line.id)))
      this.lineToModify.qty = Number.parseInt(this.lineToModify.qty)
      this.lineToModify.subprice = Number.parseFloat(this.lineToModify.subprice).toFixed(2)
      this.lineToModify.remise_percent = Number.parseFloat(this.lineToModify.remise_percent).toFixed(2)
      this.lineToModify.marque_tx = Number.parseFloat(this.lineToModify.marque_tx).toFixed(2)
      this.lineToModify.pa_ht = Number.parseFloat(this.lineToModify.pa_ht).toFixed(2)
      this.lineToModify.tva_tx = Number.parseFloat(this.lineToModify.tva_tx).toFixed(2)
      let groupParent = this.propale.lines.filter(element => (element.rang < this.lineToModify.rang) && (element.product_type == 9) && (element.qty > 0 && element.qty < 10))
      if(groupParent.length){
        this.parentRang = groupParent[groupParent.length-1].rang
      }

      this.$root.$emit('bv::show::modal', 'modalModifyLine')
    },
    async submitModify(){
      await this.modifyLinePropale(this.idPropale,this.lineToModify,this.propale.ref)
      let groupParent = this.propale.lines.filter(element => (element.rang < this.lineToModify.rang) && (element.product_type == 9) && (element.qty > 0 && element.qty < 10))
      let findParent = ""
      if(groupParent.length){
        findParent = groupParent[groupParent.length-1].rang
      }
      if((this.parentRang != "")&&(this.parentRang != findParent)){
        let to = {rang:Number.parseInt(this.parentRang)+1}
        let from = {rang:this.lineToAdd.rang, id:this.lineToModify.idLine}
        let reorderTable = []
        reorderTable = this.propale.lines.filter(element => (element.rang >= to.rang)&&(element.rang != this.lineToAdd.rang))
        await this.changeRang(to,from,reorderTable,this.propale.ref)
      }
      await this.loadPropale(this.idPropale)
      this.resetData()

      //Hide modal
      this.$root.$emit('bv::hide::modal', 'modalModifyLine')
    },

    //Changement prix unitaire HT
    changePuHt(){
      let errors = []
      this.lineToModify.subprice = Number.parseFloat(this.lineToModify.subprice).toFixed(2)
      if((isNaN(this.lineToModify.subprice))||(this.lineToModify.subprice <= 0)){
        errors.push({content:"Le prix unitaire HT doit être un nombre supérieur à 0",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        let remise = 0
        this.lineToModify.tva_tx = Number.parseFloat(this.lineToModify.tva_tx).toFixed(2)
        this.lineToModify.marque_tx = Number.parseFloat(((Number.parseFloat(this.lineToModify.subprice)-Number.parseFloat(this.lineToModify.pa_ht))/Number.parseFloat(this.lineToModify.subprice))*100).toFixed(2)
        this.lineToModify.marge_tx = Number.parseFloat(((Number.parseFloat(this.lineToModify.subprice)-Number.parseFloat(this.lineToModify.pa_ht))/Number.parseFloat(this.lineToModify.pa_ht))*100).toFixed(2)
        if(this.lineToModify.remise_percent){
          remise = Number.parseFloat((this.lineToModify.subprice*this.lineToModify.qty)*(this.lineToModify.remise_percent/100)).toFixed(2)
        }
        this.lineToModify.total_ht = Number.parseFloat(this.lineToModify.qty*this.lineToModify.subprice)-remise
        this.lineToModify.total_tva = Number.parseFloat(this.lineToModify.qty*((this.lineToModify.subprice*this.lineToModify.tva_tx)/100))
        this.lineToModify.total_ttc = Number.parseFloat(this.lineToModify.total_ht+this.lineToModify.total_tva).toFixed(2)
        this.lineToModify.multicurrency_subprice = this.lineToModify.subprice
        this.lineToModify.multicurrency_total_ht = this.lineToModify.total_ht
        this.lineToModify.multicurrency_total_tva = this.lineToModify.total_tva
        this.lineToModify.multicurrency_total_ttc = this.lineToModify.total_ttc
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement prix d'achat HT
    changePaHt(){
      let errors = []
      this.lineToModify.pa_ht = Number.parseFloat(this.lineToModify.pa_ht).toFixed(2)

      if((isNaN(this.lineToModify.pa_ht))||(this.lineToModify.pa_ht <= 0)){
        errors.push({content:"Le prix d'achat HT doit être un nombre supérieur à 0",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        let remise = 0
        this.lineToModify.tva_tx = Number.parseFloat(this.lineToModify.tva_tx).toFixed(2)
        this.lineToModify.marque_tx = Number.parseFloat(((Number.parseFloat(this.lineToModify.subprice)-Number.parseFloat(this.lineToModify.pa_ht))/Number.parseFloat(this.lineToModify.subprice))*100).toFixed(2)
        this.lineToModify.marge_tx = Number.parseFloat(((Number.parseFloat(this.lineToModify.subprice)-Number.parseFloat(this.lineToModify.pa_ht))/Number.parseFloat(this.lineToModify.pa_ht))*100).toFixed(2)
        if(this.lineToModify.remise_percent){
          remise = Number.parseFloat((this.lineToModify.subprice*this.lineToModify.qty)*(this.lineToModify.remise_percent/100)).toFixed(2)
        }
        this.lineToModify.total_ht = Number.parseFloat(this.lineToModify.qty*this.lineToModify.subprice)-remise
        this.lineToModify.total_tva = Number.parseFloat(this.lineToModify.qty*((this.lineToModify.subprice*this.lineToModify.tva_tx)/100))
        this.lineToModify.total_ttc = Number.parseFloat(this.lineToModify.total_ht+this.lineToModify.total_tva).toFixed(2)
        this.lineToModify.multicurrency_subprice = this.lineToModify.subprice
        this.lineToModify.multicurrency_total_ht = this.lineToModify.total_ht
        this.lineToModify.multicurrency_total_tva = this.lineToModify.total_tva
        this.lineToModify.multicurrency_total_ttc = this.lineToModify.total_ttc
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement du taux de marque
    changeMarque(){
      let errors = []
      this.lineToModify.marque_tx = Number.parseFloat(this.lineToModify.marque_tx).toFixed(2)
      this.lineToModify.subprice = Number.parseFloat((Number.parseFloat(this.lineToModify.pa_ht)/(100-Number.parseFloat(this.lineToModify.marque_tx)))*100).toFixed(2)

      if((isNaN(this.lineToModify.marque_tx))||(this.lineToModify.marque_tx < 0)){
        errors.push({content:"Le taux de marque doit être un nombre supérieur à 0",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        let remise = 0
        this.lineToModify.tva_tx = Number.parseFloat(this.lineToModify.tva_tx).toFixed(2)
        this.lineToModify.marge_tx = Number.parseFloat(((Number.parseFloat(this.lineToModify.subprice)-Number.parseFloat(this.lineToModify.pa_ht))/Number.parseFloat(this.lineToModify.pa_ht))*100).toFixed(2)
        if(this.lineToModify.remise_percent){
          remise = Number.parseFloat((this.lineToModify.subprice*this.lineToModify.qty)*(this.lineToModify.remise_percent/100)).toFixed(2)
        }
        this.lineToModify.total_ht = Number.parseFloat(this.lineToModify.qty*this.lineToModify.subprice)-remise
        this.lineToModify.total_tva = Number.parseFloat(this.lineToModify.qty*((this.lineToModify.subprice*this.lineToModify.tva_tx)/100))
        this.lineToModify.total_ttc = Number.parseFloat(this.lineToModify.total_ht+this.lineToModify.total_tva).toFixed(2)
        this.lineToModify.multicurrency_subprice = this.lineToModify.subprice
        this.lineToModify.multicurrency_total_ht = this.lineToModify.total_ht
        this.lineToModify.multicurrency_total_tva = this.lineToModify.total_tva
        this.lineToModify.multicurrency_total_ttc = this.lineToModify.total_ttc
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement de la quantité
    changeQuantite(){
      let errors = []
      this.lineToModify.qty = Number.parseInt(this.lineToModify.qty)

      if((isNaN(this.lineToModify.qty))||(this.lineToModify.qty <= 0)){
        errors.push({content:"La quantité doit être un entier supérieur à 0",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        let remise = 0
        if(this.lineToModify.remise_percent){
          remise = Number.parseFloat((this.lineToModify.subprice*this.lineToModify.qty)*(this.lineToModify.remise_percent/100)).toFixed(2)
        }
        this.lineToModify.total_ht = Number.parseFloat(this.lineToModify.qty*this.lineToModify.subprice)-remise
        this.lineToModify.total_tva = Number.parseFloat(this.lineToModify.qty*((this.lineToModify.subprice*this.lineToModify.tva_tx)/100))
        this.lineToModify.total_ttc = Number.parseFloat(this.lineToModify.total_ht+this.lineToModify.total_tva).toFixed(2)
        this.lineToModify.multicurrency_subprice = this.lineToModify.subprice
        this.lineToModify.multicurrency_total_ht = this.lineToModify.total_ht
        this.lineToModify.multicurrency_total_tva = this.lineToModify.total_tva
        this.lineToModify.multicurrency_total_ttc = this.lineToModify.total_ttc
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement de la description
    changeDesc(){
      let errors = []

      if(!this.lineToModify.description.length){
        errors.push({content:"La description ne peut pas être vide",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        this.lineToModify.desc = this.lineToModify.description
        this.lineToModify.product_desc = this.lineToModify.description
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement du label
    changeLabel(){
      let errors = []

      if(!this.lineToModify.label.length){
        errors.push({content:"Le titre ne peut pas être vide",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement du libelle
    changeLibelle(){
      let errors = []

      if(!this.lineToModify.libelle.length){
        errors.push({content:"Le libelle ne peut pas être vide",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement de la remise
    changeRemise(){
      let errors = []
      this.lineToModify.remise_percent = Number.parseFloat(this.lineToModify.remise_percent).toFixed(2)

      if((isNaN(this.lineToModify.remise_percent))||(this.lineToModify.remise_percent < 0)){
        errors.push({content:"Le taux de marque doit être un nombre supérieur à 0",title:"Ajout impossible"})
      }
      if(errors.length){
        let content = this.$createElement("ul", errors.map(x => this.$createElement("li", x.content))) // generates a VNode ul with li children
        this.$bvToast.toast(content, {
          title: this.$createElement('div', {class: "text-danger"}, "Le formulaire est mal renseigné"),
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
          toaster: "b-toaster-bottom-right",
        })
      }else{
        let remise = 0
        this.lineToModify.tva_tx = Number.parseFloat(this.lineToModify.tva_tx).toFixed(2)
        this.lineToModify.marque_tx = Number.parseFloat(((Number.parseFloat(this.lineToModify.subprice)-Number.parseFloat(this.lineToModify.pa_ht))/Number.parseFloat(this.lineToModify.subprice))*100).toFixed(2)
        this.lineToModify.marge_tx = Number.parseFloat(((Number.parseFloat(this.lineToModify.subprice)-Number.parseFloat(this.lineToModify.pa_ht))/Number.parseFloat(this.lineToModify.pa_ht))*100).toFixed(2)
        if(this.lineToModify.remise_percent){
          remise = Number.parseFloat((this.lineToModify.subprice*this.lineToModify.qty)*(this.lineToModify.remise_percent/100)).toFixed(2)
        }
        this.lineToModify.total_ht = Number.parseFloat(this.lineToModify.qty*this.lineToModify.subprice)-remise
        this.lineToModify.total_tva = Number.parseFloat(this.lineToModify.qty*((this.lineToModify.subprice*this.lineToModify.tva_tx)/100))
        this.lineToModify.total_ttc = Number.parseFloat(this.lineToModify.total_ht+this.lineToModify.total_tva).toFixed(2)
        this.lineToModify.multicurrency_subprice = this.lineToModify.subprice
        this.lineToModify.multicurrency_total_ht = this.lineToModify.total_ht
        this.lineToModify.multicurrency_total_tva = this.lineToModify.total_tva
        this.lineToModify.multicurrency_total_ttc = this.lineToModify.total_ttc
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    //Changement de la TVA
    changeTVA(){
        this.lineToModify.tva_tx = Number.parseFloat(this.lineToModify.tva_tx).toFixed(2)
        this.lineToModify.total_tva = Number.parseFloat(this.lineToModify.qty*((this.lineToModify.subprice*this.lineToModify.tva_tx)/100))
        this.lineToModify.total_ttc = Number.parseFloat(this.lineToModify.total_ht+this.lineToModify.total_tva).toFixed(2)
        this.lineToModify.multicurrency_subprice = this.lineToModify.subprice
        this.lineToModify.multicurrency_total_ht = this.lineToModify.total_ht
        this.lineToModify.multicurrency_total_tva = this.lineToModify.total_tva
        this.lineToModify.multicurrency_total_ttc = this.lineToModify.total_ttc
        this.lineToModify.date_modification = moment().format("YYYY-MM-DD HH:mm:ss")
    },

    //Retourne vrai si des produits existent au dessus du sous-total
    productTopExist(item){
      if(this.propale){
        let find = this.propale.lines.filter(line => line.product_type != 9 && line.rang < item.rang)
        if(find.length){
          return true
        }else{
          return false
        }
      }
    },

    //Retourne le total HT des produits existant au dessus du sous-total
    getTotalTopProduct(item){
      if(this.propale){
        let products = this.propale.lines.filter(line => line.product_type != 9 && line.rang < item.rang)
        let total = 0
        if(products.length){
          products.forEach(product => {
            console.log(Number.parseFloat(product.total_ht).toFixed(2))
            console.log(total)
            total = Number.parseFloat(total+product.total_ht).toFixed(2)
          })
        }
        return total
      }
    }

  },
  mounted: function () {
    this.verifyTiers()
  },
  components: {
    draggable,
  },
  computed:{
    tableProduct(){
      let product = []
      if(this.propale){
        this.propale.lines.forEach(line => {
          if(line.product_type == 9){
            if(line.qty == 50){
              product.push({
                id:line.id,
                ref:"Texte libre",
                description:line.desc,
                quantite:null,
                paht:null,
                pvht:null,
                tva:null,
                marque:null,
                totalht:null,
                rang: line.rang,
                productType: line.product_type
              })
            }else if(line.qty > 89 && line.qty < 100){
              product.push({
                id:line.id,
                ref:"Sous-total",
                description:line.label,
                quantite:line.qty,
                paht:null,
                pvht:null,
                tva:null,
                marque:null,
                totalht:null,
                rang: line.rang,
                productType: line.product_type
              })
            }else{
              product.push({
                id:line.id,
                ref:"Titre de niveau "+line.qty,
                description:line.label,
                quantite:null,
                paht:null,
                pvht:null,
                tva:null,
                marque:null,
                totalht:null,
                rang: line.rang,
                productType: line.product_type
              })
            }
          }else if(line.fk_product){
            product.push({
              id:line.id,
              ref:line.ref,
              description:line.libelle,
              quantite:line.qty,
              paht:this.convertNumber(line.pa_ht),
              pvht:this.convertNumber(line.subprice),
              tva:this.convertNumber(line.tva_tx),
              marque:this.convertNumber(line.marque_tx),
              totalht:this.convertNumber(line.total_ht),
              rang: line.rang,
              productType: line.product_type
            })
          }else{
            product.push({
              id:line.id,
              ref:line.ref,
              description:line.desc,
              quantite:line.qty,
              paht:this.convertNumber(line.pa_ht),
              pvht:this.convertNumber(line.subprice),
              tva:this.convertNumber(line.tva_tx),
              marque:this.convertNumber(line.marque_tx),
              totalht:this.convertNumber(line.total_ht),
              rang: line.rang,
              productType: line.product_type
            })
          }
        })
      }
      return product
    },
    propalePart(){
      let part = []
      if(this.propale){ 
        this.propale.lines.forEach(line => {
          if(line.product_type == 9){
            if((line.qty != 50)&&(line.qty != 99)){
              part.push({
                text:line.label,
                value:line.rang,
              })
            }
          }
        })
      }
      return part
    },
    levelTitle(){
      let levels = []
      for(var i = 1; i < 10; i++){
        levels.push({text:"niveau " + i, value: i})
      }
      return levels
    },
    levelSousTotal(){
      let levels = []
      let j = 1
      for(var i = 10; i > 1; i--){
        levels.push({text:"niveau " + j, value: 89+i})
        j++
      }
      return levels
    },
    infosTiers(){
        return this.$store.state.infoSoc
    },
    propale(){
      return this.$store.state.currentPropale
    }
  }
}
</script>

<style scoped>
#infoDevis{
  flex: 1 1 45%;
  margin-right: 5%;
}

#infoProduit{
  flex: 1 1 45%;
}

#tableProduct >>> .descriptionProduct{
  width: 20em;
  max-width: 20em;
}

#tableProduct >>> .prixProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .tvaProduct{
  width: 6em;
  max-width: 6em;
}

#tableProduct >>> .qtyProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .reducProduct{
  width: 6em;
  max-width: 6em;
}

#selectType{
  margin-bottom: 1em;
}

#selectTypeLine{
  margin-bottom: 1em;
}

#formPropal{
  display: flex;
}

.actionBarPropal{
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: end;
  padding: 1em;
  background: white;
}

.headerPropale{
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.headerPropale p{
  margin: 0;
}

.infosTiers{
  flex: 0 0 20%;
}

.recapPropale{
  flex: 0 0 70%;
}

.statusPropale{
  flex: 0 0 10%;
  text-align: center;
}

.searchProduct{
}

.searchProduct .el-autocomplete{
  width: 400px;
}

.freeProduct,.headerFreeProduct,.searchProduct{
  padding-bottom: 1em;
  padding-top: 1em;
}

.fonctSupp{
  padding-bottom: .5em;
}

.addProduct{
  padding-bottom: 1em;
}

.dateServiceProduct{
  width: 100%;
}

.fonctProduct{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: space-between;
}

.listProduct .table tr:nth-child(even) {
  background-color: #f2f2f2;
}

#modalLine #formAddLine{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: flex-end;
}

#modalModifyLine #formModifyLine{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: flex-end;
}

#modalText #formTextToAdd{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: flex-end;
}

#modalTitle #formTitleToAdd{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: flex-end;
}

#modalSousTotal #formSousTotalToAdd{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: flex-end;
}

#modalGlobalPourcent #formGlobalPourcentToAdd{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: flex-end;
}

#modalText .textareaLineToAdd{
  width: 80%;
}

#modalText .selectLineToAdd{
  width: 10%;
}

#modalModifyLine .inputLineToModify{
  width: 10%;
}

#modalModifyLine .selectLineToModify{
  width: 10%;
}

#modalModifyLine .textareaLineToModify{
  width: 40%;
}
</style>
<style>
#modalLine .modal-dialog.modal-md, #modalModifyLine .modal-dialog.modal-md, #modalText .modal-dialog.modal-md{
  max-width: 70%;
}

.productPopover{
  height: 300px;
  overflow: auto;
}
</style>